export const DETAILED_ACCOUNTING_CHECKLIST_FILTERS = {
  name: 'detailed-settlements-checklist',
  filters: [],
};
